(function() {
'use strict';

angular
    .module('dashboard')
    .factory('paymentDetailsService', paymentDetailsService);

function paymentDetailsService($http, $interval, $location, $q, $rootScope, $timeout, dateUtil, resourceService, currentUser, bookingService) {
    const url = '/api2/payments/cards/customer/';
    const cardUrl = '/api2/payments/cards/';
    const transactionUrl = '/api2/payments/transactions/';
    const baseUrl = '/api2/payments/';
    const ddcTokenUrl = TRPCONFIG.Domain2.CPGIframeUpdate ? '/api2/payments/transactions/getcpgclienttoken' : '/api2/payments/tokens/ddctoken';

    const service = {
        getPaymentTypes,
        getPaymentCards,
        getPaymentOptions,
        getSavedPaymentCards,
        clearPayment,
        authorisePayment,
        authorisePaymentByCPGStatus,
        getCpgStatus,
        getcardFailureReasonCode,
        getcardFailureReasonMessage,
        getPaymentLogos,
        convertToPaymentCards,
        validateCard,
        getDeviceDataCollectionToken
    };

    const cardFailureReasonCode = {
        Unknown: 0,
        InvalidCardNumber: 1,
        InvalidCardNumberLength: 2,
        CardHasExpired: 3,
        CardNotYetValid: 4,
        InvalidIssueNumber: 5
    };

    const cardFailureReasonMessage = {
        0: 'INVALIDCARD',
        1: 'INVALIDCARDNUMBER',
        2: 'INVALIDCARDNUMBERLENGTH',
        3: 'CARDHASEXPIRED',
        4: 'CARDNOTYETVALID',
        5: 'INVALIDISSUENUMBER'
    };

    function getcardFailureReasonCode() {
        return cardFailureReasonCode;
    }

    function getcardFailureReasonMessage(reasonCode) {
        return resourceService.get(cardFailureReasonMessage[reasonCode]);
    }

    //Payment Details
    function getPaymentCards() {
        return $http.get(`${url}get`, { ignoreErrors: true }).then(function(result) {
            return result.data;
        });
    }

    function getPaymentTypes(uniqueMasterCards, bookingType) {
        const allTypeOfCards = 0;
        return $http.get(`${cardUrl}gettypes?${$.param({
                domainId: TRPCONFIG.Domain.DomainId,
                currencyCode: TRPCONFIG.Domain.CurrencyCode,
                bookingTypeId: bookingType || allTypeOfCards
        })}`, { cache: true, ignoreErrors: true }).then(function(result) {
            if (uniqueMasterCards) {
                //if uniqueMasterCards is requested. return unique types with respect to MasterdCardId.
                return _uniqueMasterCards(result.data);
            }
            //else return result as it is.
            return result.data;
            });
    }


    function _uniqueMasterCards(allCards) {
        const uniqueCards = [];
        const seen = {};
        const len = allCards.length;
        let j = 0;
        for (let i = 0; i < len; i++) {
            const card = allCards[i];
            const masterId = card.MasterCardTypeId;
            if (seen[masterId] !== 1) {
                seen[masterId] = 1;
                uniqueCards[j++] = card;
            }
        }
        return uniqueCards;
    }
    //End- Payment Details

    function getSavedPaymentCards(bookingType, bookingId, clientCurrencyCode) {
        //getsavedbookingcards is obsolete now. So calling get and joining with PaymentOptions
        const getOptions = service.getPaymentOptions(bookingType, bookingId, clientCurrencyCode);
        const getCards = TRPCONFIG.Domain.SavedCardsEnabled && currentUser.get() && currentUser.get().HardSignedIn ? service.getPaymentCards() : null;

        return $q.all([getOptions, getCards]).then(function(results) {
            return convertToPaymentCards(...results);
        });
    }

    function convertToPaymentCards(options, cards) {
        const paymentCards = [];
        _.each(cards, card => {
            const paymentOption = _.find(options, o => o.CardType === card.MasterCardTypeId);
            if (paymentOption && !card.IsExpired) {
                card.CardTypeId = paymentOption.Id;//In payment directive PaymentOptionId is named as CardTypeId
                paymentCards.push(card);
            }
        });
        return paymentCards;
    }

    function getCardTypeId() {
        document.addEventListener('click', e => {
            let seEl = document.querySelectorAll('select[name="paymentType"]')[0];
            if (e.target.classList.value.includes('button')) {
                let cardTypeId = seEl.value;
                if (cardTypeId !== '') {
                    cardTypeId = cardTypeId.split(':');
                    cardTypeId = Number(cardTypeId[1]);
                    TRPCONFIG.Domain.CardTypeId = cardTypeId;
                }
            }
        }, true);
    }

    function getPaymentOptions(bookingType, bookingId, currencyCode) {
        if (TRPCONFIG.Domain2.CPGIframeUpdate) {
            TRPCONFIG.Domain.CardTypeId = 370;
        } else {
            getCardTypeId();
        }
        return $http.get(`${baseUrl}getpaymentoptionsforbooking?${$.param({
            DomainId: TRPCONFIG.Domain.DomainId,
            CurrencyCode: currencyCode,
            BookingTypeId: bookingType,
            BookingId: bookingId
        })}`, { cache: true, ignoreErrors: true }).then(function(result) {
            return result.data;
        });
    }

    function validateCard(request) {
        return $http.post(`${cardUrl}validate`, request).then(function(result) {
            return result.data;
        });
    }

    function getDeviceDataCollectionToken(cardTypeId, timeout) {
        const requestParams = {
            domainId: TRPCONFIG.Domain.DomainId,
            currencyCode: TRPCONFIG.Domain.CurrencyCode,
            cardTypeId
        };
        const networkParams = {
            ignoreErrors: true
        };
        if (timeout) {
            networkParams.timeout = timeout;
        }

        let res;

        if (TRPCONFIG.Domain2.CPGIframeUpdate) {
            res = $http.get(`${ddcTokenUrl}?domainId=${requestParams.domainId}&cardTypeId=${requestParams.cardTypeId}&currencyCode=${requestParams.currencyCode}`)
                    .then(result => result.data);
        } else {
            res = $http.post(`${ddcTokenUrl}`, requestParams, networkParams)
                    .then(result => result.data);
        }

        return res;
    }

    //Transaction
    function clearPayment(request, requireCardValidation) {

        if (TRPCONFIG.Domain2.CPGIframeUpdate) {
            return _clear(request);
        }

        if (requireCardValidation) {
            const validateRequest = {
                CardNumber: TRPCONFIG.Domain.PCICompliant ?
                    request.CardNumberMasked : request.CardNumber,
                StartDate: dateUtil.serialiseDate(new Date(request.CardStartYear, request.CardStartMonth)),
                ExpiryDate: dateUtil.serialiseDate(new Date(request.CardEndYear, request.CardEndMonth)),
                CV2: request.CardCvc,
                IssueNumber: request.CardIssueNumber
            };

            return validateCard(validateRequest).then(function(response) {
                if (response.Success) {
                    return _clear(request);
                }
                return $q.when(response);
            });
        }

        return _clear(request);
    }

    function _clear(request) {
        const updatedReq = {
            ...request,
            BrowserDetails: bookingService.browserDetails()
        };

        if (TRPCONFIG.Domain2.CPGIframeUpdate) {
            updatedReq.PaymentOptionId = 370;
            updatedReq.PaymentTypeId = 36;
        }

        return $http.post(`${transactionUrl}clear`, updatedReq).then(function(result) {
            sessionStorage.setItem('PaymentPopup', 'true');
            return result.data;
        });
    }

    function authorisePayment(request) {
        return $http.post(`${transactionUrl}authorise`, request).then(function(result) {
            return result.data;
        });
    }

    function authorisePaymentByCPGStatus(bookingId, paymentId) {
        const siteID = TRPCONFIG.Domain.DomainId;
        return $http.get(`${transactionUrl}getcpgorderstatusforpostbookingpayment?bookingId=${bookingId}&siteId=${siteID}&paymentId=${paymentId}`).then(function(result) {
            return result.data;
        });
    }

    function getCpgStatus(bookingId, paymentId) {
        const pollDelayMs = TRPCONFIG.Domain.CpgStatusIntervalDelay;
        const stopApiMs = TRPCONFIG.Domain.CpgStatusTimeout;
        if (!paymentId) {
            return null;
        }
        const siteID = TRPCONFIG.Domain.DomainId;
        const cpgstatusURL = `${transactionUrl}getcpgorderstatusforpostbookingpayment?bookingId=${bookingId}&siteId=${siteID}&paymentId=${paymentId}`;
        return $q(res => {
            let interval = $interval(() => {
                $http.get(`${cpgstatusURL}`).then(result => {
                    const postBookingPath = $location.path();

                    if (result.data === 'SUCCESS') {
                        const cpgStatus = result.data;
                        const authCode =
                            result.data && result.data;
                        const paRes =
                            cpgStatus === 'SUCCESS'
                                ? `^${authCode}^^^AUTHORISED`
                                : '';

                        const response = {
                            paRes,
                            paymentId,
                            error: '',
                        };
                        res(response);
                        $interval.cancel(interval);
                    }

                    if (postBookingPath && !postBookingPath.includes('pay-balance')) {
                        console.log('cpgStatus cancelled');
                        const response = {
                            paRes: '',
                            paymentId: '',
                            error: '',
                        };
                        res(response);
                        $interval.cancel(interval);
                    }

                    if (result && result.status !== 200) {
                        console.log('cpgStatus result.status', result.status);
                        const response = {
                            paRes: '',
                            paymentId: '',
                            error: '',
                        };
                        res(response);
                        $interval.cancel(interval);
                    }

                    if (result.data === 'FAILED') {
                        // payment failed so stop polling
                        // Log an error?
                        const error = 'FAILED';
                        const response = {
                            paRes: '',
                            paymentId: '',
                            error,
                        };
                        res(response);
                        $interval.cancel(interval);
                    }

                    if (result.data === 'STOP') {
                        // stop polling
                        // Duplicate, log error
                        console.log('stop polling');
                        const response = {
                            paRes: '',
                            paymentId: '',
                            error: '',
                        };
                        res(response);
                        $interval.cancel(interval);
                    }
                });
            }, pollDelayMs);

            $timeout(() => {
                $interval.cancel(interval);
                const error = 'TIMER';
                const response = {
                    paRes: '',
                    paymentId: '',
                    error,
                };
                $rootScope.$broadcast('cpgStatusAPIError', response);
            }, stopApiMs);
        });
    }

    function getPaymentLogos() {
        const parameters = $.param({
            domainId: TRPCONFIG.Domain.DomainId,
            currencyCode: TRPCONFIG.Domain.CurrencyCode,
            bookingTypeId: 8
        });
        const url = `${baseUrl}getpaymentoptions?${parameters}`;
        return $http.get(url, { cache: true, ignoreErrors: true }).then(result => result.data);
    }

    return service;
}
})();
